import LoginTimeout from './LoginTimeout';

export default LoginTimeout;
